<template lang="pug">
  div
    template(v-if="initialized")
      TheNavbar

      .container(v-if="materials.length")
        .d-flex.flex-column.justify-content-around
          .d-flex.justify-content-center
            BPaginationNav.top-pagination(:number-of-pages="totalPages" v-model="currentPage" :link-gen="linkGen")

          transition(name="fade-slide" mode="out-in")
            .row.my-5.flex-fill-fix(:key="materials.map(({ id }) => id).join('_')")
              .col-12.col-sm-6.col-lg-4.col-xl-3.mb-4(v-for="material in materials" :key="material.id")
                MaterialCard(
                  :material="material"
                  :show-route="{ name: 'show', params: { materialSlug: material.slug, categorySlug: material.categorySlug } }"
                )

          .d-flex.justify-content-center
            BPaginationNav.bottom-pagination(:number-of-pages="totalPages" v-model="currentPage" :link-gen="linkGen")

      .bg-porcelain.my-3.py-2(v-else)
        .container
          .row
            .col
              span.text-scorpion Материалов не найдено
    .text-center(v-else-if="loading")
      .spinner-border.text-alto.my-5
</template>

<script>
  import { toRefs, watch } from '@vue/composition-api';

  import TheNavbar from '@app/edu_materials/components/index/TheNavbar';
  import MaterialCard from '@app/edu_materials/components/MaterialCard';

  import { fetchData, state } from '@app/edu_materials/stores/index-store';

  export default {
    components: {
      MaterialCard,
      TheNavbar,
    },

    setup (_, context) {
      const {
        materials,
        loading,
        initialized,
        totalPages,
        currentPage,
        selectedCategorySlug,
        selectedAuthorSlug,
        search,
      } = toRefs(state);

      // Restore state from route params/query
      state.selectedCategorySlug = context.root.$route.params.categorySlug;
      state.selectedAuthorSlug = context.root.$route.query.author;
      state.currentPage = parseInt(context.root.$route.query.page, 10) || 1;

      // Request data as state changes
      watch([selectedCategorySlug, selectedAuthorSlug, currentPage, search], () => {
        fetchData();
      }, { immediate: true });

      // Sync state to route params/query
      watch([selectedCategorySlug, selectedAuthorSlug, currentPage], ([categorySlug, authorSlug, page]) => {
        const { $route, $router } = context.root;
        $router.push({
          name: 'index',

          params: {
            ...$route.params,
            categorySlug,
          },

          query: {
            ...$route.query,
            author: authorSlug,
            page,
          },
        });
      });

      // Reset page on other parameters change
      watch([selectedCategorySlug, selectedAuthorSlug, search], () => {
        currentPage.value = 1;
      });

      return {
        materials,
        initialized,
        loading,
        totalPages,
        currentPage,
        paginate: ['materials'],
        linkGen: (page) => ({ name: 'index', params: { categorySlug: state.selectedCategorySlug }, query: { page } }),
      };
    },
  };
</script>

<style lang="scss" scoped>
  .loading {
    opacity: .5;
    pointer-events: none;
  }

  .top-pagination ::v-deep .b-pagination {
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .bottom-pagination ::v-deep .b-pagination {
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .fade-slide-enter-active {
    transition: opacity .15s ease-in .1s, transform .15s ease-out .1s;
  }

  .fade-slide-leave-active {
    transition: opacity .15s ease-in, transform .15s ease-in;
  }

  .fade-slide-enter, .fade-slide-leave-to {
    opacity: 0;
  }

  .fade-slide-enter {
    transform: translateY(-24px);
  }

  .fade-slide-leave-to {
    transform: translateY(24px);
  }


  ::v-deep .b-pagination {
    background: $porcelain;
    border-radius: 0;
    overflow: auto;
    margin: 0;

    .page-item {
      > * {
        background: none;
        border: none;
      }

      .page-link {
        display: block;
        padding: 9px 10px;
        cursor: pointer;
        user-select: none;
        border-bottom: 3px solid transparent;
        color: $scorpion;

        &:hover {
          background: white;
        }

        &:focus {
          box-shadow: none;
        }
      }

      &.active .page-link {
        background: white;
        color: $java;
        border-bottom-color: $java;
      }

      &.disabled .page-link {
        color: $alto;
        &:hover {
          background: transparent;
        }
      }
    }
  }
</style>
